module.exports = __webpack_public_path__ + "img/bling.e0f8fef3.svg";